import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Mk3Instructions, NIBInstructions, NIBQuoteRequest, RRInstructions, RRQuoteRequest } from '@app/_helpers/constants';
import { Contractor } from '@app/_models/contractor';
import { EmailRecord } from '@app/_models/email-record';
import { JobStatus } from '@app/_models/job-status';
import { AlertService } from '@app/_services';
import { FunctionsService } from '@app/_services/functions.service';
import { GlobalValues } from '@app/_services/global-values';
import { RestService } from '@app/_services/rest.service';
import { UtilsService } from '@app/_services/utils.service';
import { AppComponent } from '@app/app.component';
import { InputRefNoDialog } from '@app/home';
import { MsalService } from '@azure/msal-angular';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-claim-instructions',
  templateUrl: './claim-instructions.component.html',
  styleUrls: ['./claim-instructions.component.scss']
})
export class ClaimInstructionsComponent implements OnInit {
  
  displayedEmailRecordsColumns: string[] = [
    'id',
    'tradeName',
    'instructionTypeId',
    'attachmentName',
    'dateSent',
    'sentBy',
    'statusId',
    'details',
    'viewDocument',
    'retract'
  ];
  isLoading = true;
  refNo!:number;
  isValidRefNo!:boolean;
  dataSourceEmailRecords!: MatTableDataSource<any>;
  dataSourceForEmailRecords!: MatTableDataSource<any>;
  searchValueInstructionAll = '';
  searchValue = '';
  jobStatusesArray: Array<JobStatus> = [];
  contractor = <Contractor>{};
   @ViewChild(MatSort, { static: false })
  matSortCommon: MatSort = new MatSort();
  paginator!: MatPaginator;
  @ViewChild(MatPaginator) set _paginator(paginator: MatPaginator) {
    this.paginator = paginator;
    if (this.dataSourceEmailRecords) this.dataSourceEmailRecords.paginator = this.paginator;
  }
  pageSizeControl = new FormControl(
    localStorage.getItem('instructionsPageSize')
      ? Number(localStorage.getItem('instructionsPageSize'))
      : 15
  );
  instructionType:string[]=[];
  inputDialogRef: any;

constructor(
    private globalValues:GlobalValues,
    public restService: RestService,
    private route: ActivatedRoute,
    private router: Router,
    public appComponent: AppComponent,
    public functionsService: FunctionsService,
    public dialog: MatDialog,
    private cdRef: ChangeDetectorRef,
    private msalService: MsalService,
    private alertService: AlertService,
    private datePipe: DatePipe,
    private utils:UtilsService
    ) {
      // if (this.route.snapshot.params.refNo===0){
      //       this.alertService.error(
      //         'Invalid RefNo ' +
      //           refNo +
      //           '. This claim either could be archived or not yet registered. Please contact Mk3 IT-Helpdesk'
      //       );
      //     }
      // else {
        // this.route.queryParams.subscribe(params => {
        //   this.isValidRefNo = params['isValidRefNo'] === 'true';;
        // });

        this.refNo = this.route.snapshot.params.refNo;
        this.restService.getInstructionsAllByRefNo(this.refNo).subscribe({
          next: (emailRecords) => {
            this.dataSourceEmailRecords = new MatTableDataSource(emailRecords);
            this.dataSourceForEmailRecords =this.dataSourceEmailRecords;
            this.dataSourceEmailRecords.filteredData.forEach(item => {
              item.jobStatus = this.getJobStatus(item.statusId);
              item.instructionType = this.instructionType[item.instructionTypeId];
            });
            this.dataSourceEmailRecords.filter = this.searchValue ? this.searchValue : '';
            this.dataSourceEmailRecords.sort = this.matSortCommon;
            this.dataSourceEmailRecords.paginator = this.paginator;
         if (
            this.pageSizeControl.value != null &&
            this.pageSizeControl.value > 100 &&
            this.dataSourceEmailRecords.data.length !=
              Number(localStorage.getItem('instructionsPageSize'))
          ) {
            console.log(
              'pageSizeControl.value: ' + this.dataSourceEmailRecords.data.length.toString()
            );
            localStorage.setItem(
              'instructionsPageSize',
              this.dataSourceEmailRecords.data.length.toString()
            );
          }
            this.isLoading = false;
          },
          error: (error) => {
            this.isLoading = false;
            this.alertService.error(error);
          },
        });
      //}
    }

  async ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.isValidRefNo = params['isValidRefNo'] === 'true';
      this.cdRef.detectChanges();
    });
    // this.isValidRefNo = await this.restService.isValidCaseID(this.refNo);
    // if (!this.isValidRefNo){
    //   //this.router.navigate(['.']);
    //   this.alertService.error(
    //           'Invalid RefNo ' +
    //             this.refNo +
    //             '. This claim either could be archived or not yet registered. Please contact Mk3 IT-Helpdesk'
    //         );
    // }
    this.instructionType[1] = NIBInstructions;
    this.instructionType[2] = NIBQuoteRequest;
    this.instructionType[3] = RRInstructions;
    this.instructionType[4] = RRQuoteRequest;
    this.instructionType[5] = Mk3Instructions;
    this.restService.getJobStatuses().subscribe((jobStatuses: JobStatus[]) => {
      this.jobStatusesArray = jobStatuses;
    });
  }

openInputRefNoDialog() {
    this.inputDialogRef = this.dialog.open(InputRefNoDialog, {
      minWidth: '400px',
      maxWidth: '1000px',
    });
}

  async retract(emailRecordId: number) {
    this.isLoading = true;
    await this.utils.retractEmailRecord(emailRecordId,this.contractor.tradingName,this.contractor.contractorId,'Contractor','instruction');
    this.isLoading = false;
    }

  getJobStatus(statusId: number) {
    return this.jobStatusesArray.find((item) => item.id == statusId)
      ?.description;
  }

  jobDetails(jobId: number) {
    this.router.navigate(['../job-details/' + jobId], {
      queryParams: { tabId: 4 },
    });
  }

  openInstructionPDF(emailRecordId: number) {
    this.restService.getEmailRecord(emailRecordId).subscribe(
      (data: EmailRecord) => {
        this.functionsService.openPdf(data.pdfData);
      },
      (error) => {
        this.alertService.error(error);
      }
    );
  }

  onSearchKeyUp(search: { value: any },tab :string) {
    try {
      this.searchValueInstructionAll =search.value;
      var currentFilter = search.value;
      this.filterInstructions(currentFilter);
      
    } catch (error) {
      Swal.fire('Error in Search by keyword : ' + error, '', 'error');
    }
  }
   
  filterInstructions(currentFilter: string)
  {
    let result;
    if (currentFilter && currentFilter.length > 0) {
      this.isLoading = true;
      result = this.dataSourceForEmailRecords.filteredData.filter(item => (item.refNo != null && item.refNo.toString().includes(currentFilter)) || 
                                        (item.id != null && item.id.toString().includes(currentFilter)) || 
                                        (item.instructionType != null && item.instructionType.toLowerCase().includes(currentFilter.toLowerCase())) || 
                                        (item.jobStatus != null && item.jobStatus.toLowerCase().includes(currentFilter.toLowerCase())) || 
                                        (item.attachmentName != null && item.attachmentName.toLowerCase().includes(currentFilter.toLowerCase())) || 
                                        (item.sentBy != null && item.sentBy.toLowerCase().includes(currentFilter.toLowerCase()))
                                    )
      this.dataSourceEmailRecords = new MatTableDataSource(result);
      this.isLoading = false;
      
    } else if (currentFilter == null || currentFilter.length == 0) {
      result = this.dataSourceForEmailRecords.filteredData;
      this.dataSourceEmailRecords = new MatTableDataSource(result);
      this.isLoading = false;
    }
    this.dataSourceEmailRecords.sort = this.matSortCommon;
  }

  onClearClicked(search: { value: string },tab :string) {
    this.dataSourceForEmailRecords.filter = '';
    search.value ='';
    this.searchValueInstructionAll ='';
    this.dataSourceEmailRecords = new MatTableDataSource(this.dataSourceForEmailRecords.filteredData);
       this.isLoading = false;
  }

    onPageSizeChange() {
    // Save the new page size to localStorage when the user selects a new page size
    localStorage.setItem('instructionsPageSize', this.paginator.pageSize.toString());
  }
}
